import React from 'react'
import { useHistory ,useNavigate} from 'react-router-dom'

import { useAuth } from '../../components/AuthProvider'
import Spinner from '../../components/Loader/Spinner'
import Logo from '../../components/Logo'
import Card from '../../components/Card'

import { APP_NAME } from '../../utils/constants'

import styles from './CreateSession.module.scss'

const CreateSession = () => {

  // eslint-disable-next-line no-unused-vars
  const [isLoading, setIsLoading] = React.useState(false)
  const [hasLoaded, setHasLoaded] = React.useState(false)
  const history = useNavigate()

  const [{ error, redirectRoute }, { createSession }] = useAuth()

  React.useEffect(() => {
    const cs = async (
      id_token,
      client_info,
      session_state,
      state,
      code_verifier
    ) => {
      await createSession(
        id_token,
        client_info,
        session_state,
        state,
        code_verifier
      )
    }
    const hash = window.location.hash
    const params = new URLSearchParams(hash.substring(1))

    if (!hasLoaded) {
      setIsLoading(true)
      cs(
        params.get('id_token'),
        params.get('client_info'),
        params.get('session_state'),
        params.get('state'),
        params.get('code_verifier')
      ).then(() => {
        setIsLoading(false)
        setHasLoaded(true)

        var redirectTo = redirectRoute
        if (redirectRoute === '/login') {
          redirectTo = '/Home'
        }

        history(redirectTo, { replace: true })
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (error) {
    return (
      <div className={styles.base}>
        <div className={styles.container}>
          <div className={styles.logo}>
            <Logo color="#fff" />
          </div>

          <Card className={styles.loginCard}>
            <div className={styles.appName}>
              <span>{APP_NAME}</span>
            </div>
            <div className={styles.loginPreference}>
              <p>
                Filed to log you into the application. If this issue persists
                please contact the IDP team.
              </p>
            </div>
          </Card>
        </div>
      </div>
    )
  }
// Inline styles keep this change self-contained; small, responsive, centered card
  const wrapperStyle = {
    minHeight: '60vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px'
  }

  const cardStyle = {
    background: 'white',
    borderRadius: 12,
    boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
    padding: '28px 30px',
    maxWidth: 420,
    width: '100%',
    textAlign: 'center',
    boxSizing: 'border-box'
  }

  const titleStyle = {
    fontSize: 18,
    fontWeight: 600,
    marginBottom: 8,
    color: '#102A43'
  }

  const subtitleStyle = {
    fontSize: 14,
    marginBottom: 18,
    color: '#334E68'
  }

  const spinnerStyle = {
    width: 48,
    height: 48,
    borderRadius: '50%',
    border: '4px solid rgba(16,42,67,0.12)',
    borderTopColor: '#0B66C2',
    animation: 'spin 1s linear infinite',
    margin: '0 auto 14px'
  }
  return (
    <div style={wrapperStyle}>
      <div style={cardStyle}>
        <div style={spinnerStyle} aria-hidden="true" />
        <div style={titleStyle}>Logging you into the system...</div>
        <div style={subtitleStyle}>You will be sent to the dashboard page shortly.</div>
        <div style={{ fontSize: 13, color: '#627D98' }}>If you are not redirected automatically, please wait or check your browser settings.</div>

        {/* simple keyframes for the spinner; injected via style tag to keep file self-contained */}
        <style>{`@keyframes spin { from { transform: rotate(0deg) } to { transform: rotate(360deg) } }`}</style>
      </div>
    </div>
    // <div className={styles.base}>
    //   <div className={styles.container}>
    //     <div className={styles.logo}>
    //       <Logo color="#fff" />
    //     </div>

    //     <Card className={styles.loginCard}>
    //       <div className={styles.appName}>
    //         <span>{APP_NAME}</span>
    //       </div>
    //       <div className={styles.loginPreference}>
    //         <Spinner /> Logging you into the system...
    //       </div>
    //     </Card>
    //   </div>
    // </div>
  )
}

export default CreateSession
